import React, { useRef } from "react";
import Trending1 from "../../assets/pic/popular-cards/1.svg";
import Trending2 from "../../assets/pic/popular-cards/new_image.png";
import Trending3 from "../../assets/pic/popular-cards/3.svg";
import Trending4 from "../../assets/pic/popular-cards/4.svg";
import Trending5 from "../../assets/pic/popular-cards/5.svg";
import Trending6 from "../../assets/pic/popular-cards/6.svg";
import Trending7 from "../../assets/pic/popular-cards/7.svg";
import Trending8 from "../../assets/pic/popular-cards/8.svg";
import whiteArrow from "../../assets/pic/whiteArrow.svg";
import shadow from "../../assets/pic/shadow.svg";
import { Pagination, Scrollbar, A11y, Navigation } from "swiper/modules";
import leftCaraousal from "../../assets/pic/leftcaraousal.svg";
import rightCaraousal from "../../assets/pic/rightCaraousal.svg";
import { Link } from "react-router-dom";
import { LayoutForLandingPage } from "./Home";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
const TrendingCards = () => {
  const swiperRef = useRef(null);
  const trendingCards = [
    { title: "Valentine Card", url: Trending1 },
    { title: "Thinking Of You Card", url: Trending2 },
    { title: "Fathers Day Card", url: Trending3 },
    { title: "Thinking Of You Card", url: Trending4 },
    { title: "Birthday Card", url: Trending5 },
    { title: "Birthday Card", url: Trending6 },
    { title: "New Baby Card", url: Trending7 },
    { title: "Graduation Card", url: Trending8 },
  ];

  return (
    <div
      style={{
        background: "linear-gradient(to right, #E5CDE080, #ADDDC380)",
        padding: "2px",
      }}
    >
      <h2 className="md:text-5xl flex justify-center gap-4 text-3xl text-center my-10">
        <span className="text-[#2F3649] font-semibold">Trending</span>{" "}
        <span className="text-[#F66061] font-semibold">Cards</span>
      </h2>
      <LayoutForLandingPage>
        {/* Swiper Carousel */}
        <Swiper
          ref={swiperRef}
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          slidesPerView={1} // Initially, show one card
          spaceBetween={40} // Spacing between cards
          breakpoints={{
            640: { slidesPerView: 1 }, // Show 1 card on small screens
            768: { slidesPerView: 2 }, // Show 2 cards on medium screens
            1024: { slidesPerView: 4 }, // Show 4 cards on large screens
          }}
          navigation={false}
          style={{
            paddingBottom: "40px",
            paddingLeft: "10px",
            paddingRight: "10px",
          }} // Add left and right padding
        >
          {trendingCards.map(({ title, url }, index) => (
            <SwiperSlide>
              <div className="item">
                <div className=" rounded-lg flex flex-col items-center justify-center py-2 h-72">
                  <img
                    src={url}
                    alt="Trending Cards 1"
                    className="rounded-sm"
                    width={160}
                  />
                  <img className="mt-2" src={shadow} alt="" />
                </div>
                <div className="flex items-center justify-center my-3">
                  <h2 className="md:text-2xl text-md font-semibold">{title}</h2>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* Swiper Arrows */}
        <div className="flex justify-center gap-2 mt-4">
          <img
            className="react-swiper-prev cursor-pointer"
            onClick={() => swiperRef.current.swiper.slidePrev()} // Go to previous slide
            src={leftCaraousal}
            alt=""
          />
          <img
            className="react-swiper-next cursor-pointer"
            onClick={() => swiperRef.current.swiper.slideNext()}
            src={rightCaraousal}
            alt=""
          />
        </div>

        {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-14 max-w-7xl mx-auto">
          <div className="item">
            <div className="bg-white rounded-lg flex flex-col items-center justify-center py-2 h-72">
              <img
                src={Trending1}
                alt="Trending Cards 1"
                className="rounded-sm"
                width={160}
              />
              <img className="mt-2" src={shadow} alt="" />
            </div>
            <div className="flex items-center justify-center my-3">
              <h2 className="md:text-2xl text-md font-semibold">
                Mothers Day Card
              </h2>
            </div>
          </div>

          <div className="item">
            <div className="bg-white rounded-md flex flex-col items-center justify-center py-2 h-72">
              <img
                src={Trending2}
                alt="Trending Cards 2"
                className="rounded-sm"
                width={160}
              />
              <img className="mt-2" src={shadow} alt="" />
            </div>
            <div className="flex items-center justify-center my-3">
              <h2 className="md:text-2xl text-md font-semibold">
                Fathers Day Card
              </h2>
            </div>
          </div>

          <div className="item">
            <div className="bg-white rounded-md flex flex-col items-center justify-center py-2 h-72">
              <img
                src={Trending3}
                alt="Trending Cards 3"
                className="rounded-sm"
                width={160}
              />
              <img className="mt-2" src={shadow} alt="" />
            </div>
            <div className="flex items-center justify-center my-3">
              <h2 className="md:text-2xl text-md font-semibold">
                Birthday Card
              </h2>
            </div>
          </div>

          <div className="item">
            <div className="bg-white rounded-md flex flex-col items-center justify-center py-2 h-72">
              <img
                src={Trending4}
                alt="Trending Cards 4"
                className="rounded-sm"
                width={160}
              />
              <img className="mt-2" src={shadow} alt="" />
            </div>
            <div className="flex items-center justify-center my-3">
              <h2 className="md:text-2xl text-md font-semibold">
                Baby Shower Card
              </h2>
            </div>
          </div>
        </div> */}
      </LayoutForLandingPage>
      <Link
        to={"/browse_cards"}
        className="flex my-10 items-center justify-center w-fit m-auto"
      >
        <button className=" mx-auto border-2 rounded-md bg-[#F66061] hover:bg-primary-dark text-white md:text-xl text-md px-12 py-2">
          <span className="flex gap-2">
            View All <img src={whiteArrow} alt="" />
          </span>
        </button>
      </Link>
    </div>
  );
};

export default TrendingCards;
